import React, { useState } from "react";
import { Link } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import "../styles/Auth.css";
import { FaTimes } from "react-icons/fa";

const Signup = ({ isPopup = false, onClose, onSwitchToLogin }) => {
  const [form, setForm] = useState({
    name: "",
    email: "",
    mobile: "",
    password: ""
  });

  const [error, setError] = useState("");
  const [success, setSuccess] = useState("");
  const [loading, setLoading] = useState(false);

  const { signup } = useAuth();

  const handleChange = (e) => {
    setForm({ ...form, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const { name, email, mobile, password } = form;

    if (!name || !email || !mobile || !password) {
      return setError("All fields are required");
    }

    // if (password !== confirmPassword) {
    //   return setError("Passwords do not match");
    // }

    setLoading(true);
    setError("");
    setSuccess("");

    const result = await signup(name, email, mobile, password);

    if (result.success) {
      setSuccess("Account created successfully. Please login.");
      setForm({
        name: "",
        email: "",
        mobile: "",
        password: "",
      });

      if (isPopup) {
        setTimeout(onSwitchToLogin, 1500);
      }
    } else {
      setError(result.message);
    }

    setLoading(false);
  };

  return (
    <div className={`auth-container ${isPopup ? "popup-mode" : ""}`}>
      <div className="auth-form">
        {isPopup && (
          <button className="auth-close-btn" onClick={onClose}>
            <FaTimes />
          </button>
        )}

        <h2>Sign Up</h2>

        {error && <div className="error-message">{error}</div>}
        {success && <div className="success-message">{success}</div>}

        <form className="formalll" onSubmit={handleSubmit}>
          {["name", "email", "mobile"].map((field) => (
            <div key={field} className="form-grouplog">
              <label>{field.toUpperCase()}</label>
              <input
                type={field === "email" ? "email" : "text"}
                name={field}
                value={form[field]}
                onChange={handleChange}
                required
              />
            </div>
          ))}

          <div className="form-grouplog">
            <label>Password</label>
            <input
              type="password"
              name="password"
              value={form.password}
              onChange={handleChange}
              required
            />
          </div>

          {/* <div className="form-grouplog">
            <label>Confirm Password</label>
            <input
              type="password"
              name="confirmPassword"
              value={form.confirmPassword}
              onChange={handleChange}
              required
            />
          </div> */}

          <button className="auth-button" disabled={loading}>
            {loading ? "Creating..." : "Sign Up"}
          </button>
        </form>

        {!isPopup && (
          <div className="auth-link">
            Already have an account? <Link to="/login">Login</Link>
          </div>
        )}
      </div>
    </div>
  );
};

export default Signup;
